import { DocumentTypeFormDto, type DocumentTypeFormInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DocumentTypeCodeValidateTools } from '@zaoblako/shared/modules/document/classes/document.type.code.validate.tools';

/** Document type create API request body - DTO signature */
export interface DocumentTypeCreateInterface extends DocumentTypeFormInterface {
  /** Document type code. Unique for tenant. Using to generate document codes. */
  code: string;
}

/** Document type create API request body - DTO schema */
export const DocumentTypeCreateDto = SerdeDtoClass.from<DocumentTypeFormInterface, DocumentTypeCreateInterface>(
  DocumentTypeFormDto,
  DocumentDtoKeysEnum.DOCUMENT_TYPE_CREATE_DTO,
  {
    code: {
      label: 'Код типа документа',
      serializer: () => DocumentTypeCodeValidateTools
        .getInstance()
        .yupSchema,
    },
  },
);
